var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"answer-state-icon",class:_vm.cls.mainClass,attrs:{"data-testid":"answer-state"}},[(_vm.cls.iconClass)?_c('i',{staticClass:"fa",class:_vm.cls.iconClass,attrs:{"data-testid":"answer-state-icon"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }